export const ACRONYMS = []
